import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NumericDataTypeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "NumericDataType",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M19.74 29.77c-.86-.09-1.44-.78-1.36-1.55l.63-6.26h-7.8l-.66 6.54c-.08.73-.68 1.27-1.41 1.27h-.18c-.75-.08-1.31-.78-1.24-1.55l.63-6.26H3.42c-.78 0-1.42-.63-1.42-1.42s.63-1.42 1.42-1.42h5.24l.71-7.07H3.73a1.419 1.419 0 1 1 0-2.84h5.92l.58-5.71c.07-.73.67-1.27 1.41-1.27h.15c.77.08 1.34.77 1.27 1.55l-.54 5.42h7.8l.58-5.71c.07-.73.67-1.27 1.41-1.27h.15c.77.08 1.34.77 1.27 1.55l-.54 5.42h5.42c.78 0 1.42.63 1.42 1.42s-.63 1.42-1.42 1.42h-5.7l-.71 7.07h6.1c.78 0 1.42.63 1.42 1.42s-.63 1.42-1.42 1.42h-6.38l-.66 6.54c-.08.73-.68 1.27-1.41 1.27h-.06l-.02.02Zm-8.25-10.66h7.8l.71-7.07h-7.8z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M3.29 12.43c-.63 0-1.14-.51-1.14-1.14s.51-1.14 1.14-1.15l27.43-.08c.63 0 1.14.51 1.14 1.14s-.51 1.14-1.14 1.15zM28.43 21.57H1a1.14 1.14 0 1 1 0-2.28h27.43a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.71 31.86a1.145 1.145 0 0 1-1.11-1.44L13.57.7c.17-.61.79-.97 1.4-.81s.97.79.81 1.4L7.82 31c-.14.51-.6.85-1.1.85ZM17.04 31.86a1.145 1.145 0 0 1-1.11-1.44L23.9.7c.16-.61.79-.97 1.4-.81s.97.79.81 1.4L18.15 31c-.14.51-.6.85-1.1.85Z"
      })]
    })
  }));
};
NumericDataTypeIcon.displayName = 'NumericDataTypeIcon';